var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalModels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4.5,
    fill: "#1570EF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3816_8181)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 24.75C19.7902 24.75 21.5071 24.0388 22.773 22.773C24.0388 21.5071 24.75 19.7902 24.75 18C24.75 16.2098 24.0388 14.4929 22.773 13.227C21.5071 11.9612 19.7902 11.25 18 11.25C16.2098 11.25 14.4929 11.9612 13.227 13.227C11.9612 14.4929 11.25 16.2098 11.25 18C11.25 19.7902 11.9612 21.5071 13.227 22.773C14.4929 24.0388 16.2098 24.75 18 24.75ZM18 28.125C20.6853 28.125 23.2606 27.0583 25.1595 25.1595C27.0583 23.2606 28.125 20.6853 28.125 18C28.125 15.3147 27.0583 12.7393 25.1595 10.8405C23.2606 8.94174 20.6853 7.875 18 7.875C15.3147 7.875 12.7393 8.94174 10.8405 10.8405C8.94174 12.7393 7.875 15.3147 7.875 18C7.875 20.6853 8.94174 23.2606 10.8405 25.1595C12.7393 27.0583 15.3147 28.125 18 28.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3816_8181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.25,
    height: 20.25,
    fill: "white",
    transform: "translate(7.875 7.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalModels);
export default __webpack_public_path__ + "static/media/TotalModels.aac67b3f889c11fa555d5a128b938c58.svg";
export { ForwardRef as ReactComponent };